<div class="system-report-summary-card-progress-bar">
    <!-- 'progress-block' and 'progress-group' are classes defined by Clarity -->
    <div class="progress-block">
        <div class="progress-group">
            <clr-progress-bar
                [clrValue]="value"
                [clrMax]="maxValue"
                class="progress-group__{{ iconColorClass }}"
            ></clr-progress-bar>
            <span class="progress-group__title"> {{ value }} </span>
        </div>
    </div>
</div>
